// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import moment from 'moment';
import App from './App';

import './assets/css/common.less';

import router from './router';
// 引入lke统一渲染插件
import lkeComponent from 'lke-component';

Vue.use(lkeComponent);
const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

Vue.config.productionTip = false;
Vue.prototype.moment = moment;
// 前端区分UI交互的端类型
Vue.prototype.webIMSource = 'client';

try {
    (async () => {
        let sseMixin = await import('@/manage/sse');
        Vue.mixin(sseMixin);
        new Vue({
            el: '#app',
            router,
            render (h) {
                return h(App);
            }
        }).$mount('#app');
    })();
} catch (error) {
    console.error('main.js instal error>>', error);
}



// WEBPACK FOOTER //
// ./src/main.js